module.exports = __webpack_public_path__ + "res/20-img_bg_l.cb2f3552961f785f84bc58370e251b38.png";